import React from 'react';
import { Alert } from 'react-bootstrap';

import Icon from '../Icon/Icon';

import styles from './ErrorAlert.module.scss';

import plusIcon from '../../../../assets/add_dark.svg';

export interface ErrorAlertProps {
  text: string;
  hidden?: boolean;
  close?: () => void;
}

const ErrorAlert = ({ text, hidden, close }: ErrorAlertProps) => {
  const alertClassNames = [styles.error_alert];
  if (hidden) alertClassNames.push(styles.error_alert__hidden);

  return (
    <Alert variant="danger" className={alertClassNames.join(' ')}>
      {text}

      <Icon
        dark
        alt="close"
        src={plusIcon}
        onClick={close!}
        style={{
          transform: 'rotate(45deg)',
          float: 'right',
        }}
      />
    </Alert>
  );
};

ErrorAlert.defaultProps = {
  hidden: false,
  close: () => {},
};

export default ErrorAlert;
